import React from 'react';
import { StylePillFormField, StylePillFormFieldLabel, StylePillFormFieldLabelInfo, styles } from './ProductVariantFormField.styles';
import { ProductVariantFormFieldProps } from './types';

export const ProductVariantFormField: React.FC<ProductVariantFormFieldProps> = ({ children, label, helperText, error, ...restProps }: ProductVariantFormFieldProps) => {
  return (
    <StylePillFormField {...restProps}>
      <StylePillFormFieldLabel typeVariant="label3" as="label" __css={styles.pillFormFieldLabel}>
        {label}{' '}
        <StylePillFormFieldLabelInfo as="span" error={error}>
          {helperText}
        </StylePillFormFieldLabelInfo>
      </StylePillFormFieldLabel>
      {children}
    </StylePillFormField>
  );
};
